<template>
  <div class="">
  </div>

</template>

<script>

export default {}
</script>


<style>
.single-product-background-1,
.single-product-background-2,
.single-product-background-3 {
  background-color: white;
}

</style>